const binding = { modules: {}, dataActions: {} };

    (binding.modules['bju-onboarding-form'] = {
        c: () => require('partner/modules/bju-onboarding-form/bju-onboarding-form.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'bju-onboarding-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/bju-onboarding-form'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|bju-onboarding-form|bju-onboarding-form'] = {
                c: () => require('partner/modules/bju-onboarding-form/bju-onboarding-form.view.tsx'),
                cn: '__local__-__local__-bju-onboarding-form'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };